<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-2 pe-5">
    <a (click)="back()">
      <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
    </a>

    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">Elegí hasta 3 fechas</h1>
    </div>

    <div class="p-2 pl-2 help" (click)="openhelp()">
      <i class="bi bi-info-circle"></i>
    </div>
  </div>

  @if (helpOpen()) {
    <div class="row m-3 p-3 align-items-center tooltip-pwa tooltip-pwa--open" id="tooltip-pwa" style="display:flex;">
      <div class="col-auto"><i class="bi bi-info-circle" style="font-size: 1.8em;"></i></div>
      <div class="col">{{ helpText() }}</div>
      <div class="col-auto" (click)="openhelp()">
        <i class="bi bi-x-lg" style="font-size: 1.4em;"></i>
      </div>
    </div>
  }

  <div class="row p-3 mb-0 align-items-center">
    <div class="mt-2 text-center">
      <ngb-datepicker [dayTemplate]="customDay" (dateSelect)="selectOne($event)"></ngb-datepicker>

      <ng-template
        #customDay
        let-date
        let-currentMonth="currentMonth"
        let-selected="selected"
        let-focused="focused">
        <span
          class="custom-day"
          [class.focused]="focused"
          [class.bg-primary]="isSelected(date)"
          >{{ date.day }}</span
        >
      </ng-template>
    </div>

    <hr class="divisor mt-4 mb-2" />

    <!-- Sections -->
    <form (ngSubmit)="saveFechaTurno()" (keydown.enter)="$event.preventDefault()" [formGroup]="fechaTurno">
      <div class="mt-2">
        <div class="row form-switch ps-0 m-3">
          <div class="col"><b>Mañana</b></div>
          <div class="col-auto">
            <input class="form-check-input ms-3" type="checkbox" formControlName="manana" />
          </div>
        </div>

        <div class="row form-switch ps-0 m-3">
          <div class="col"><b>Tarde</b></div>
          <div class="col-auto">
            <input class="form-check-input ms-3" type="checkbox" formControlName="tarde" />
          </div>
        </div>

        <div class="row form-switch ps-0 m-3">
          <div class="col"><b>Noche</b></div>
          <div class="col-auto">
            <input class="form-check-input ms-3" type="checkbox" formControlName="noche" />
          </div>
        </div>
      </div>

      @if (error()) {
        <div class="alert alert-danger mt-2" role="alert">
          <small>{{ error() }}</small>
        </div>
      }

      <div class="d-grid mt-4 mb-3 pb-3">
        <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="loadingLocal() || loadingGlobal()">
          {{ (loadingLocal() || loadingGlobal()) ? 'Cargando...' : 'Siguiente' }}
        </button>
      </div>
    </form>
  </div>
</div>